export const getErrorMessage = (axiosError) =>
  axiosError.response?.data?.errors?.message || 'Unable to perform the action'
